// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd

import {NgModule, ModuleWithProviders} from '@angular/core';

import {DragDropConfig} from './dnd.config';
import {DragDropService, dragDropServiceFactory} from './dnd.service';
import {DraggableDirective, DraggableHandleDirective} from './draggable.directive';
import {DroppableDirective} from './droppable.directive';

export * from './abstract.component';
export * from './dnd.config';
export * from './dnd.service';
export * from './draggable.directive';
export * from './droppable.directive';

export let providers = [
  DragDropConfig,
  {provide: DragDropService, useFactory: dragDropServiceFactory},
];

@NgModule({
  declarations: [DraggableDirective, DraggableHandleDirective, DroppableDirective],
  exports: [DraggableDirective, DraggableHandleDirective, DroppableDirective],
})
export class DndModule {
  static forRoot(): ModuleWithProviders<DndModule> {
    return {
      ngModule: DndModule,
      providers: providers
    };
  }
}
